var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6359 22.2245L17.8969 24.2681C17.5379 24.5359 17.325 24.9549 17.3209 25.4012C17.3167 25.8476 17.522 26.2704 17.8759 26.5447L21.9478 29.7003C22.4805 30.1132 23.2323 30.1477 23.803 29.7842C24.393 29.4084 24.6516 28.7068 24.4512 28.0567C24.4512 28.0567 23.4235 24.7229 22.8772 22.9507C22.7396 22.5046 22.3922 22.153 21.9462 22.0084C21.5001 21.8639 21.0111 21.9446 20.6359 22.2245Z",
    fill: "white",
    fillOpacity: 0.24
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3646 1.87679L10.753 10.5208C10.7177 10.6376 10.6003 10.7095 10.4736 10.7092L1.77473 10.6889C1.11773 10.6874 0.536444 11.0921 0.317557 11.6872C0.0935863 12.2962 0.289175 12.9762 0.813238 13.3808L8.023 18.9466C8.10204 19.0076 8.1399 19.1067 8.11129 19.2001L5.38378 28.0944C5.18825 28.732 5.4406 29.4202 6.01629 29.7889C6.57313 30.1455 7.30672 30.1116 7.8265 29.7066C10.0709 27.958 26.5698 15.163 28.8784 13.3808C29.4026 12.9762 29.5982 12.2962 29.3742 11.6872C29.1553 11.0921 28.574 10.6874 27.917 10.6889L19.2181 10.7092C19.0915 10.7095 18.974 10.6376 18.9387 10.5208C18.4609 8.93922 17.1957 4.75155 16.3271 1.87679C16.135 1.2411 15.5349 0.79541 14.8459 0.79541C14.1568 0.79541 13.5567 1.2411 13.3646 1.87679Z",
    fill: "white",
    fillOpacity: 0.24
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.8f1345ef87e27998d43b84d26fd12ec3.svg";
export { ForwardRef as ReactComponent };